import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Typography, Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import API from 'api/call';
import { useSelector } from 'react-redux';
import CustomButton from 'components/CustomInput/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        marginTop: theme.spacing(2),
    },
    text: {
        fontSize: '30px !important'
    }
}));

export default function AccountActivation(props) {
    const classes = useStyles();
    const systemMessage = useSelector(state => state.systemMessage.systemMessage);

    const [displayText, setDisplayText] = useState('');
    const [isError, setIsError] = useState(false);

    const history = useHistory();
    const token = history.location.search.split('?token=')[1];

    const callAccountActivation = () => {
        API.user.accountActivation({ token: token }).then(res => {
            setDisplayText(systemMessage.accountActivated);
        }).catch(err => {
            setDisplayText(err.response?.data?.errorMessage);
            setIsError(true);
        });
    };

    const toLoginPage = () => {
        props.setIsAccountActivationUrl(false);
        history.replace('/');
    };

    useEffect(() => {
        callAccountActivation();
        // eslint-disable-next-line
    }, []);

    return (
        <div className={classes.root}>
            <Grid container justify="center">
                {displayText ? <Grid container>
                    <Grid container justify="center">
                        <Typography color={isError ? 'error' : 'primary'} className={classes.text}>{displayText}</Typography>
                    </Grid>
                    <Grid container justify="center" className={classes.button}>
                        <CustomButton onClick={toLoginPage}>
                            Go to Login
                        </CustomButton>
                    </Grid>
                </Grid>
                : <CircularProgress />}
            </Grid>
        </div>
    );
}
